export const CONTACT_LABEL="CONTACT_LABEL";

export const QUESTION_FORM_TITLE="QUESTION_FORM_TITLE";
export const QUESTION_FORM_SUBTITLE="QUESTION_FORM_SUBTITLE";